import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { zone: String }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 60000)
  }

  disconnect() { clearInterval(this.timer) }

  update() {
    const now = new Date()
    this.element.dateTime = now.toISOString()
    this.element.textContent = new Intl.DateTimeFormat("en-US", {
      timeZone: this.zoneValue, hour: "numeric", minute: "2-digit", hour12: true
    }).format(now).replace(/\s/g, "").toLowerCase()
  }
}
